import { FastForward, Monitor, AlignCenter } from 'react-feather';

const pagesSection = [
  // {
  //   href:"/choose-report",
  //   icon:FastForward,
  //   title:"Start Here"
  // },
  {
    href: '/dashboard',
    icon: Monitor,
    title: 'Dashboard',
  },
  {
    href: '#',
    icon: AlignCenter,
    title: 'Disputes',
    children: [
      {
        href: '#',
        title: 'Submit Dispute',
      },
      {
        href: '#',
        title: 'Dispute Status',
      },
      {
        href: '#',
        title: 'Mail Dispute',
      },
    ],
  },
  {
    href: '#',
    icon: AlignCenter,
    title: 'Reports & Scores',
    children: [
      {
        href: '/credit-builder',
        title: 'Credit Buildr',
      },
      {
        href: '#',
        title: 'Score Breakdown',
      },
      {
        href: '#',
        title: 'Accounts',
      },
    ],
  },
];

const navItems = [
  {
    title: 'Menu',
    pages: pagesSection,
  },
];

export default navItems;
